import { Theme } from '@mui/material/styles'

import { typography as typeTokens } from '../tokens.generated'

// ----------------------------------------------------------------------
// A divider is a hairline in the divider colour, and nothing else.
//
// `<Divider textAlign="left">Status</Divider>` is what puts floating text on a
// hairline: a word with a line running through the card behind it, which the
// design audit filed as a defect. Regions inside a card separate by tone and
// space, not by a hairline with a legend. So a divider that carries children
// drops both of its lines and renders the text as a panel label instead: 11px,
// bold, uppercase, tracked, in the muted text role. The two screens that use
// the pattern get the label with no change to their markup, and `SectionPanel`
// takes the pattern over properly in the primitives pass.
// ----------------------------------------------------------------------

export default function Divider(theme: Theme) {
  const { label } = typeTokens.console

  return {
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.divider,
        },
        withChildren: {
          '&::before, &::after': {
            display: 'none',
          },
        },
        wrapper: {
          paddingInline: 0,
          fontSize: theme.typography.pxToRem(label.size),
          fontWeight: typeTokens.weights.bold,
          letterSpacing: label.letterSpacing,
          textTransform: 'uppercase' as const,
          // grey[500] is the muted text role in both schemes.
          color: theme.palette.grey[500],
        },
      },
    },
  }
}
